<template>
	<div class="info-area">
		<el-dropdown trigger="click" @command="dropdownComm" class="info-area__dropdown">
			<span class="el-dropdown-link">
				{{username}}<i class="el-icon-arrow-down el-icon--right"></i>
			</span>
			<el-dropdown-menu slot="dropdown">
				<!-- <el-dropdown-item command="profile">{{$t('sidebarDropDown.profile')}}</el-dropdown-item> -->
				<!-- <el-dropdown-item command="lock">{{$t('sidebarDropDown.lock')}}</el-dropdown-item> -->
				<el-dropdown-item command="logout">{{$t('sidebarDropDown.logout')}}</el-dropdown-item>
				<el-dropdown-item command="changePSW">{{$t('sidebarDropDown.changePSW')}}</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<el-dialog 
			:visible.sync="AddDialogTableVisible"
			title="修改密码" 
			top="60px"
			@closed="cancleAddForm('AddForm')"
			width="540px"
			:close-on-click-modal="false">
			<!-- 表单 -->
			<el-form ref="AddForm" :model="AddForm" label-width="140px" :rules="AddRules" style="width:100%;">
				<el-form-item label="旧密码" prop="old_password">
					<el-input v-model="AddForm.old_password" name="old_password" auto-complete="off" type="password" placeholder="请输入原始密码" style="width: 260px" minlength="6"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="new_password">
					<el-input v-model="AddForm.new_password" name="new_password" auto-complete="off" type="password" placeholder="(6位以上/不能纯数字/字母/符号)" style="width: 260px"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="re_Password">
					<el-input v-model="AddForm.re_Password" name="re_Password" auto-complete="off" type="password" placeholder="请再次输入新密码" style="width: 260px"></el-input>
				</el-form-item>
				<el-form-item class="text-align-right">
					<el-button type="primary" @click="submitAddForm('AddForm')">提交</el-button>
					<el-button @click="cancleAddForm('AddForm')">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- <div @click="jumpToProfile" class="info-area__avatar">
			<img :src="avatarUrl" />
		</div> -->
		<div class="info-area__avatar">
			<!-- <img :src="avatarUrl" /> -->
			<img src="@/assets/images/avatar.jpg" />
		</div>
	</div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'

export default {
	name: 'demo',
	data() {
		//密码验证
		var checkPassword = (rule, value, callback) => {        
			if (!value) {           
				return callback(new Error('密码不能为空'));         
			} else {          
				const reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,}$/;
				console.log(reg.test(value));          
				if (reg.test(value)) {            
					callback();         
				} else {            
					return callback(new Error('请输入6位以上密码(不能纯数字/字母/符号)'));          
				}     
			}
		};
		//确认密码
		var checkConfirmPassword = (rule, value, callback) => {        
			if (!value) {           
				return callback(new Error('请再次输入新密码'));         
			} else {     
				const psw = this.AddForm.new_password;
				console.log('repws: '+value);   
				console.log('pws: '+psw)  
				if (psw == value) {            
					callback();         
				} else {            
					return callback(new Error('两次输入的密码不一致'));          
				}     
			}
		};
		return {
			username: '',
			/* 新增部分 */
			AddDialogTableVisible : false, //默认隐藏
			AddForm : {
				old_password: '',
				new_password: '',
				re_Password: ''
			},
			AddRules : {
				old_password : [{required: true, message : '请输入旧密码', trigger: 'blur', min: 6}],
				new_password : [{required: true, validator: checkPassword, trigger: 'blur'}],
				re_Password: [{required: true, validator: checkConfirmPassword, trigger: 'blur'}]
			},
			//avatarUrl: this.$store.state.user.avatar
		}
	},
	methods: {
		getUserName() {
			this.$http.post(`${api.dev}/selectAdmin`,{access_token: getToken()},{emulateJSON:true}).then(res => {
				if(res.body.code == 200) {
					this.username = res.body.content.username
				}
			})
		},
		dropdownComm(command) {
			switch (command) {
				case 'logout':
					this.logouthandle()
					break
				case 'lock':
					this.lockhandle()
					break
				case 'profile':
					this.jumpToProfile()
					break
				case 'changePSW':
					this.changePassword()
			}
		},
		async logouthandle() {
			await this.$store.dispatch('logout')
			this.$store.dispatch('closeAllView')
			window.location.reload()
		},
		changePassword(){
			this.AddDialogTableVisible = true;
			/*this.$router.push({
				path: '/profile/changePSW'
			})*/
		},
		lockhandle() {
			this.$store.dispatch('setLockState', 'lock')
			this.$router.push({
				path: '/lock'
			})
			this.$message.success(this.$t('lock.locked'))
		},
		jumpToProfile() {
			this.$router.push({
				path: '/profile/index'
			})
		},
		/* 取消新增 */
		cancleAddForm(formName) {
			this.AddDialogTableVisible = false;
			this.$refs[formName].resetFields(); // 清除表单验证规则
		},
		/* 新增提交 */
		submitAddForm(formName) {
			var that = this;
			this.$refs[formName].validate((valid) => {
				if(valid) {
					// 开启加载器
					const loading = this.$loading({
						lock: true,
						text: '正在保存中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var formdata = new FormData();
					formdata.append('access_token',getToken());
					formdata.append('old_password',this.AddForm.old_password);
					formdata.append('new_password',this.AddForm.new_password);
					this.$http.post(`${api.dev}/p/main/admin/updatePassword`,formdata, {emulateJSON:true}).then(res => {
						loading.close();
						if(res.body.code == 200) {
							this.$message({
								message: res.body.msg + ' 请重新登录',
								type: 'success'
							})
							setTimeout(function () {
								that.logouthandle()
							},2000)
						}else if(res.body.code == 500) {
							this.$message({
								message: res.body.msg,
								type: 'error'
							});
						}else if(res.body.code == 510) {
							this.$message({
								message: res.body.msg,
								type: 'error'
							});
							removeToken();
							setTimeout(function () {
								that.$router.push({path: '/login'})
							},2000)
						}
					})
				}
			})
		},
	},
	created() {
		this.getUserName()
	}
}
</script>

<style lang="stylus" scoped>
.inline-block-box
	display inline-block
	vertical-align middle

.info-area
	&__dropdown
		@extend .inline-block-box
		cursor pointer
	&__avatar
		@extend .inline-block-box
		padding-left 10px
		width 40px
		height 40px
		overflow hidden
		cursor pointer
		img
			border-radius 50%
			width 100%
			height auto

.info-area__avatar
	cursor default
</style>
